import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { BehaviorSubject, Observable } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { User } from "../_models/user.model";
import { map, tap } from "rxjs/operators";

const API_URL = environment.baseApi + "/auth";

@Injectable({
  providedIn: "root",
})
export class AuthService {
  private server = {
    login: API_URL + "/login",
  };

  private currentUserSubject: BehaviorSubject<User>;
  public currentUser: Observable<User>;

  constructor(private http: HttpClient) {
    this.currentUserSubject = new BehaviorSubject<User>(JSON.parse(localStorage.getItem('currentUser')));
    this.currentUser = this.currentUserSubject.asObservable();
  }

  public get currentUserValue(): User {
    return this.currentUserSubject.value;
  }

  login(email, password) {
    return this.http
      .post<any>(`${this.server.login}`, { email, password })

      .pipe(
        map((resp) => {
          // store user details and jwt token in local storage to keep user logged in between page refreshes
          localStorage.setItem(
            "currentUser",
            JSON.stringify(resp.data["user"])
          );
          localStorage.setItem("token", resp.data["access_token"]);

          this.currentUserSubject.next(resp.data["user"]);
          console.log("Guardo todo");

          return resp;
        })
      );
  }

  logout() {
    // remove user from local storage and set current user to null
    localStorage.removeItem("currentUser");
    localStorage.removeItem("token");
    location.reload();
    this.currentUserSubject.next(null);
  }

  getUser() {
    const user = localStorage.getItem("currentUser");
    return user ? JSON.parse(user) : null;
  }

  check(): boolean {
    return localStorage.getItem("token") ? true : false;
  }
}
